import i18next from '../../i18n';
import { recordApi } from '../../redux/services/record';
import { appDispatch } from '../../redux/store-accessors';
import { downloadFileFromUrl } from '../../utils/file-download';
import { dismiss, showError, showInfo, showSuccess } from '../notification.service';
import { BackgroundJobHandler } from './background-job.handler';

export abstract class ExportBackgroundJobHandler<T> extends BackgroundJobHandler<T> {
  protected toastId: string | undefined;

  // subclasses implement the specific API call
  protected abstract dispatchCreateJob(): Promise<{ backgroundJobId: number }>;

  protected getDownloadFileName(response: Record<string, string>): string {
    return response.fileName;
  }

  public async createBackgroundJob(): Promise<{ backgroundJobId: number }> {
    this.toastId = showInfo(i18next.t('exporting'), { duration: Infinity, showCloseIcon: true });
    try {
      return await this.dispatchCreateJob();
    } catch (error) {
      this.showErrorToast();
      throw error;
    }
  }

  public async getJobDetails(backgroundJobId: number) {
    const subscription = appDispatch(
      recordApi.endpoints.getBackgroundJobById.initiate(backgroundJobId, { forceRefetch: true })
    );
    return subscription.unwrap().finally(() => subscription.unsubscribe());
  }

  public successCallback(response: Record<string, string>): Promise<void> {
    return downloadFileFromUrl(response.presignedUrl, this.getDownloadFileName(response))
      .then(() => {
        dismiss(this.toastId);
        this.toastId = showSuccess(i18next.t('exported'));
      })
      .catch((error) => {
        this.showErrorToast();
        throw error;
      });
  }

  public errorCallback(): void {
    this.showErrorToast();
  }

  private showErrorToast(): void {
    dismiss(this.toastId);
    this.toastId = showError(i18next.t('file-generation-failed'));
  }
}
